import { render } from "./create-app.vue?vue&type=template&id=7f282220&scoped=true"
import script from "./create-app.vue?vue&type=script&lang=js"
export * from "./create-app.vue?vue&type=script&lang=js"

import "./create-app.vue?vue&type=style&index=0&id=7f282220&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f282220"]])

export default __exports__